import React from "react";
import { CSVLink } from "react-csv";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DataTransformations from "../_utils/reportsDataTransformations";

const CsvDownload = ({ objectData, style }) => {
  const csvData = DataTransformations.getCsvDataFromJsonReportObject(
    objectData
  );
  return (
    <span>
      <CSVLink
        target="_blank"
        data={csvData}
        filename="fcaspays-financial.csv"
        className="ant-btn"
        style={style}
      >
        <FontAwesomeIcon icon={["fal", "arrow-to-bottom"]} /> Download CSV
      </CSVLink>
    </span>
  );
};

CsvDownload.propTypes = {
  objectData: PropTypes.array,
  style: PropTypes.object
};

export default CsvDownload;



// WEBPACK FOOTER //
// ./src/views/reports/csv_download/CsvDownload.jsx